document.addEventListener('DOMContentLoaded', function () {
	var observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.addedNodes) {
				mutation.addedNodes.forEach(function (node) {
					if (node && node.id) {
						if (node.id.includes('reviewsWidgetProductSnippets')) {
							node.remove();
						}
					}
				});
			}
		});
	});

	observer.observe(document.head, {
		childList: true,
		subtree: true,
	});
});
